// extracted by mini-css-extract-plugin
export var team = "team-module--team--1Pdvs";
export var videoCard = "team-module--videoCard--XKKSA";
export var memberSpotlight = "team-module--memberSpotlight--syvjW";
export var memberSpotlightTitle = "team-module--memberSpotlightTitle--3QprB";
export var memberSpotlightName = "team-module--memberSpotlightName--5HIds";
export var memberSpotlightRole = "team-module--memberSpotlightRole--2l9iS";
export var portraitContainer = "team-module--portraitContainer--2VAmS";
export var portrait = "team-module--portrait--1m0VP";
export var bio = "team-module--bio--36W7P";